import React, {useCallback, useEffect} from 'react';
import {Box, Typography, Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const ForbiddenPage = () => {
  const navigate = useNavigate();

  const {t} = useTranslation();

  const goBack = useCallback(() => {
    navigate('/');
  }, [navigate]);

  useEffect(() => {
    const timer = setTimeout(goBack, 3000);
    return () => clearTimeout(timer);
  }, [goBack]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
    >
      <Typography variant="h1" component="div" gutterBottom></Typography>
      <Typography variant="h5" component="div" gutterBottom>
        {t('page_not_available')}
      </Typography>
      <Typography variant="body1" component="div" gutterBottom marginTop={2}>
        {t('no_permission')}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={goBack}
        sx={{
          marginTop: 2
        }}
      >
        {t('return_to_homepage')}
      </Button>
    </Box>
  );
};

export default ForbiddenPage;
